import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import MemberInfo from '../MemberItemCommon/MemberInfo.vue';
import MemberControl from '../MemberControl';
import { UserInfo } from '../../../stores/room';
import useMemberItem from './useMemberItemHooks';

interface Props {
  userInfo: UserInfo;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'indexPC',
  props: {
    userInfo: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo;
};



const { isMemberControlAccessible, openMemberControl, closeMemberControl } =
  useMemberItem(props.userInfo);

const showMemberControl = ref(false);

watch(isMemberControlAccessible, (accessible: boolean) => {
  showMemberControl.value = accessible;
});

return { __sfc: true,props, isMemberControlAccessible, openMemberControl, closeMemberControl, showMemberControl, MemberInfo, MemberControl }
}

})